import { dateRangeForPreset, type FixedRangePreset } from "./date-range-helpers";
import type { MantineDateRangeValue } from "./mantine-date-range";

export type RangePresetValue = FixedRangePreset | "custom";

export const RANGE_PRESETS: Array<{ label: string; value: RangePresetValue }> = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "This week", value: "this_week" },
  { label: "Last week", value: "last_week" },
  { label: "This month", value: "this_month" },
  { label: "Custom range", value: "custom" },
];

export const createPresetRange = (
  preset: Exclude<RangePresetValue, "custom">,
  referenceDate = new Date(),
): MantineDateRangeValue => {
  const range = dateRangeForPreset(preset, referenceDate);
  return [range.start, range.end];
};

export const DEFAULT_RANGE_PRESET: Exclude<RangePresetValue, "custom"> = "today";
export const DEFAULT_RANGE: MantineDateRangeValue = createPresetRange(DEFAULT_RANGE_PRESET);
